import styled from 'styled-components';

import { BaseButton } from '@r1-frontend/ui-react/components/buttons/baseButton';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const ChargesList = styled.div`
    padding-bottom: 32px;
    border-bottom: 2px solid ${COLORS.Control};

    @media (max-width: ${wideBreakpoints.tablet}) {
        padding-bottom: 16px;
    }
`;

export const ChargeDetail = styled.div`
    flex-direction: column;
    width: 100%;

    &:not(:last-child) {
        margin-bottom: 16px;
    }
`;

export const PaymentInfo = styled.div`
    flex-wrap: nowrap;
    align-items: flex-start;

    &:not(:only-child) {
        margin-bottom: 5px;
    }
`;

export const PaymentName = styled.div`
    ${FONTS.M}
    margin-right: auto;

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        ${FONTS.S}
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        ${FONTS.XS}
    }
`;

export const PaymentSum = styled.div`
    flex: 0 0 auto;
    align-items: center;
    ${FONTS.M};
    color: ${COLORS.TextPrimary};
    margin-left: 16px;

    span {
        ${FONTS.S};
        color: ${COLORS.TextInfo};
        margin-right: 4px;
        text-decoration: line-through;
    }

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        ${FONTS.S}

        span {
            ${FONTS.XS};
        }
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        ${FONTS.XS}

        span {
            ${FONTS.XXS}
        }
    }
`;

export const PaymentDetail = styled.ul`
    list-style-type: disc;
    padding-left: 32px;

    li {
        color: ${COLORS.Brand_Blue};

        &:not(:last-child) {
            margin-bottom: 5px;
        }

        p {
            ${FONTS.M};
            color: ${COLORS.TextInfo};
        }
    }

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        li {
            p {
                ${FONTS.S};
            }
        }
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        padding-left: 30px;

        li {
            p {
                ${FONTS.XS};
            }
        }
    }
`;

export const ShowMoreBtn = styled(BaseButton)`
    margin-top: 16px;
`;

export const TotalPayment = styled.div`
    flex-direction: column;
    margin-top: 16px;
`;

export const MonthDetail = styled.div`
    flex-direction: column;
    margin-bottom: 16px;
`;

export const TotalRow = styled.div`
    flex-wrap: nowrap;
    align-items: flex-end;

    &:not(:last-child) {
        margin-bottom: 4px;
    }
`;

export const TotalMonth = styled.div`
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: flex-end;
`;

export const TotalText = styled.h4`
    ${FONTS.H4};

    &:last-child {
        white-space: nowrap;
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        ${FONTS.H5};
    }
`;
